import Vue from 'vue'

// Замена браузерным confirm() и alert(): состояние одного общего диалога, который
// рисует AppDialog в App.vue. Вызывающая сторона получает промис с результатом,
// поэтому код остаётся таким же линейным, как с нативным confirm().
export const dialogState = Vue.observable({
	visible: false,
	kind: 'alert',
	variant: 'delete',
	title: '',
	text: '',
	confirmText: '',
	cancelText: '',
})

let resolveCurrent = null

export function settleDialog(result) {
	dialogState.visible = false

	const resolve = resolveCurrent
	resolveCurrent = null

	if (resolve) resolve(result)
}

function open(options) {
	// предыдущий диалог закрываем отказом, иначе его промис остался бы висеть
	if (resolveCurrent) settleDialog(false)

	Object.assign(dialogState, {
		visible: true,
		kind: options.kind,
		variant: options.variant || (options.kind === 'confirm' ? 'delete' : ''),
		title: options.title || '',
		text: options.text || '',
		confirmText: options.confirmText || '',
		cancelText: options.cancelText || '',
	})

	return new Promise((resolve) => {
		resolveCurrent = resolve
	})
}

function normalize(options) {
	return typeof options === 'string' ? { title: options } : options || {}
}

export const dialog = {
	// Promise<boolean>: true — пользователь подтвердил действие
	confirm(options) {
		return open({ kind: 'confirm', ...normalize(options) })
	},
	// Promise<void> — закрывается одной кнопкой
	alert(options) {
		return open({ kind: 'alert', ...normalize(options) })
	},
}

export default {
	install(VueInstance) {
		VueInstance.prototype.$dialog = dialog
	},
}
